<script setup lang="ts">
// import type { TMenu } from "@/components/shared/menu/ModernSideMenu.vue";
// import type { Dayjs } from "dayjs";
// import dayjs from "dayjs";

defineOptions({
	name: "admin.temp.dev",
});

definePage({
	name: "admin.temp.dev",
	meta: {
		hasKeepAlive: ["admin.teachers.profile"],
		permissions: "view-teacher-management",
		readableName: "All profiles",
	},
});

// const testDates = ref<Dayjs[]>([
// 	dayjs("2025-02-01", "YYYY-MM-DD"),
// 	dayjs("2025-02-02", "YYYY-MM-DD"),
// 	dayjs("2025-02-03", "YYYY-MM-DD"),
// 	dayjs("2025-02-04", "YYYY-MM-DD"),
// ]);

// const testMenuItems = ref<TMenu[]>([
// 	{
// 		heading: {
// 			title: "Title 1",
// 		},
// 		items: [
// 			{
// 				label: "Pending Teachers",
// 				name: "admin.teachers.pending",
// 			},
// 			{
// 				label: "Temp Dev",
// 				name: "admin.temp.dev",
// 			},
// 		],
// 	},
// 	{
// 		heading: {
// 			title: "Title 2",
// 		},
// 		items: [
// 			{
// 				label: "Pending Teachers",
// 				name: "admin.teachers.pending",
// 			},
// 			{
// 				label: "All Teachers",
// 				name: "admin.teachers.all",
// 			},
// 		],
// 	},
// 	{
// 		heading: {
// 			title: "Route 1",
// 			route: "admin.teachers.all",
// 		},
// 		items: [],
// 	},
// ]);

// const isSideMenuCollapsed = ref(false);

// const handleApproved = (value: boolean) => {
// 	console.log(value);
// };

// const handleDisapproved = (feedback: string) => {
// 	console.log(feedback);
// };

// const handleIsCollapsed = (value: boolean) => {
// 	isSideMenuCollapsed.value = value;
// };

// const gridLayerClick = () => {
// 	console.log("gridLayerClick");
// };

// const testEventClick = () => {
// 	console.log("testEventClick");
// };
</script>

<template>
	<div id="dev-test">
		<!-- <DisplayField
			title="Title"
			content="Content"
			:can-give-feedback="true"
			@approved="handleApproved"
			@disapproved="handleDisapproved"
		/>
		<DisplayField
			title="Title"
			content="Content"
			:can-give-feedback="false"
		/>
		<DisplayField
			title="Title 2"
			content="Content 2"
			:can-give-feedback="true"
			@approved="handleApproved"
			@disapproved="handleDisapproved"
		/>

		<DisplayField
			title="Title 3"
			content="Content 3"
			:can-give-feedback="true"
			:feedback-type="'disapproved'"
		/> -->

		<!-- <div class="calendar-container">
			<h3>Calendar Example</h3>
			<ModernCalendar :marked-dates="testDates" />
		</div> -->

		<!-- <ModernSideMenu
			:menu-items="testMenuItems"
			:is-collapsed="isSideMenuCollapsed"
			@update:is-collapsed="handleIsCollapsed"
		>
			<template #step-1-icon>
				<i-mdi-search />
			</template>
			<template #step-2-icon>
				<i-mdi-pencil-outline />
			</template>
			<template #step-3-icon>
				<i-mdi-arrow-right />
			</template>
		</ModernSideMenu> -->

		<!-- <MonthlyViewCalendar /> -->
		<NiceCalendar hide-view="month" />
		<!-- <div class="test-calendar-wrap">
			<div class="calendar-header">
				<div class="time-placeholder"></div>
				<div
					v-for="i in 7"
					:key="i"
					class="day-header"
				>
					<span>{{ i }} day</span>
				</div>
			</div>
			<div class="calendar-content">
				<div class="time-line-placeholder">
					<div
						v-for="l in 24"
						:key="l"
						class="time"
					>
						{{ l - 1 }}:00
					</div>
				</div>
				<div
					v-for="i in 7"
					:key="i"
					class="single-day-wrap"
				>
					<div class="grid-layer">
						<div
							v-for="j in 48"
							:key="j"
							class="half-hour-slot"
							@click="gridLayerClick"
						></div>
					</div>
					<div class="avl-and-booked-layer">
						<div
							v-if="i === 2"
							class="avl-slot"
						></div>
						<div
							v-if="i === 2"
							class="avl-slot magenta"
						></div>
					</div>
					<div class="lines-layer">
						<div
							v-for="k in 48"
							:key="k"
							class="ghost-half-hour-slot"
						></div>
					</div>
					<div class="events-layer">
						<div
							v-if="i === 3"
							class="test-event"
							@click="testEventClick"
						></div>
					</div>
				</div>
			</div>
		</div> -->
	</div>
</template>

<style scoped lang="scss">
/* stylelint-disable scale-unlimited/declaration-strict-value */
#dev-test {
	.test-calendar-wrap {
		padding-bottom: 20px;
		.calendar-header {
			display: grid;
			height: 40px;
			grid-template-columns: 60px repeat(7, 1fr);
			background-color: #f3f;
		}

		.calendar-content {
			display: grid;
			grid-template-columns: 60px repeat(7, 1fr);
			background-color: #ff3;

			.time-line-placeholder {
				background-color: #efe;

				.time {
					height: 30px;
					margin-bottom: 30px;
				}
			}

			.single-day-wrap {
				background-color: #a3a;
				min-height: 500px;
				border-right: 1px solid #fff;
				position: relative;

				.grid-layer {
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;

					.half-hour-slot {
						background-color: gray;
						height: 30px;
						border-bottom: 1px solid #e0e0e0;
						cursor: pointer;
					}
				}

				.avl-and-booked-layer {
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					z-index: 99;
					pointer-events: none;

					.avl-slot {
						background-color: #fff;
						position: absolute;
						width: 100%;
						height: 100px;
						top: 100px;
						left: 0;

						&.magenta {
							background-color: magenta;
							top: 110px;
							height: 50px;
						}
					}

					.booked-slot {
						background-color: magenta;
						position: absolute;
						height: 50px;
						width: 100%;
						top: 110px;
					}
				}

				.lines-layer {
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					z-index: 100;
					pointer-events: none;

					.ghost-half-hour-slot {
						height: 30px;
						background-color: transparent;
						border-bottom: 1px solid #e0e0e0;

						// z-index: 501;
					}
				}

				.events-layer {
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					z-index: 101;
					pointer-events: none;

					.test-event {
						background-color: blue;
						position: absolute;
						width: 100%;
						height: 100px;
						top: 120px;
						left: 0;
						cursor: pointer;
						pointer-events: all;
						// z-index: 102;
					}
				}
			}
		}
	}
}
// .calendar-container {
// 	margin-top: 24px;
// 	padding: 16px;
// 	background: $background-color;
// 	border-radius: 8px;
// 	box-shadow: 0 2px 10px rgb(0 0 0 / 0.1);

// 	h3 {
// 		margin-bottom: 16px;
// 		font-size: 18px;
// 		font-weight: 600;
// 		color: $text-color;
// 	}
// }
</style>
